import ar from './locales/ar.json';
import en from './locales/en.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { setAcceptLanguage } from '../api/client';

const LOCALE_KEY = 'methaq_locale';

export function getStoredLocale() {
  return localStorage.getItem(LOCALE_KEY) || 'ar';
}

export function setStoredLocale(locale) {
  localStorage.setItem(LOCALE_KEY, locale);
  setAcceptLanguage(locale);
  document.documentElement.lang = locale;
  document.documentElement.dir = locale === 'ar' ? 'rtl' : 'ltr';
}

const initialLocale = getStoredLocale();
setAcceptLanguage(initialLocale);
document.documentElement.lang = initialLocale;
document.documentElement.dir = initialLocale === 'ar' ? 'rtl' : 'ltr';

i18n.use(initReactI18next).init({
  resources: { ar: { translation: ar }, en: { translation: en } },
  lng: initialLocale,
  fallbackLng: 'ar',
  interpolation: { escapeValue: false },
});

export default i18n;
